<template>
  <Content>
    <template v-slot:topbar>
      <AddCatalogItem :inputData="inputData" />
    </template>

    <template v-slot:content>
      <template v-if="catalogItems && catalogItems.data.length > 0">
        <div class="sm:rounded-md mb-3">
          <ul role="list" class="">
            <template v-for="(item, index) in catalogItems.data" :key="index">
              <CatalogListItem :item="item" />
            </template>
          </ul>
        </div>

        <Pagination :meta="catalogItems.meta" :onPageChange="onPageChange" />
      </template>

      <template v-else>
          <p class="py-6 text-center dark:text-gray-300">
            Diemžēl nekas netika atrasts
          </p>
      </template>
    </template>
  </Content>
</template>

<script>
import { debounce } from 'vue-debounce'
import {mapGetters} from "vuex";
import Search from "@/services/Helpers/search";
import AddCatalogItem from "@/components/Settings/Catalog/CatalogItem/CatalogItemList/AddCatalogItem";
import CatalogListItem from "@/components/Settings/Catalog/CatalogItem/CatalogItemList/CatalogListItem";
import Pagination from "@/components/Components/Pagination";

export default {
  name: "Catalog",
  components: {
    AddCatalogItem,
    CatalogListItem,
    Pagination,
  },
  created() {
    this.$store.dispatch("setDataLoading", true)
  },
  mounted() {
    this.$store.dispatch('removeAllFormsForDisplay')
    this.$store.dispatch('resetSearch')
      this.$store.dispatch('getCatalogItemInputData')
    const s = Search.getSearchQuery();
    if (s) {
      this.$store.dispatch('changeSearch', s)
      this.searchCatalogItems()
    } else {
      this.$store.dispatch('getCatalogItems', Search.getCurrentPage())
    }
  },
  computed: {
    ...mapGetters({
      catalogItems: 'catalogItems',
      inputData: 'catalogItemInputData',
      formsForDisplay: 'formsForDisplay',
      editableItem: 'editableItem',
      search: 'search',
    })
  },
  watch: {
    search: function () {
      this.searchCatalogItems()
    }
  },
  methods: {
    searchCatalogItems: debounce(function () {
      this.$store.dispatch('changeSearch', this.search)
      this.$store.dispatch('getCatalogItems', Search.getCurrentPage())
    }, 500),
    onPageChange(page) {
      this.$store.dispatch('getCatalogItems', page);
      Search.changePage(this.catalogItems.meta.current_page)
    },
    showForm(formName){
      this.$store.dispatch('addFormForDisplay', formName)
    },
    displayForm(formName){
      return this.formsForDisplay.includes(formName)
    },
    hideAddCatalogItemForm(){
      this.$store.dispatch('removeAllFormsForDisplay')
    },
  }
}
</script>